import styled from "styled-components";

export const RulePanel = styled.section`
  grid-area: rule;
  display: flex;
  flex-direction: column;
`;
